import { createIcon, Icon } from '@chakra-ui/react'

const FileIcon = props => {
    return (
        <Icon viewBox="0 0 32 32" fill="none" {...props}>
            <path
                d="M17 3H6V29H25.9992V12M17 3L25.9992 12M17 3V12H25.9992"
                stroke="#333333"
                strokeWidth="3"
            />
        </Icon>
    )
}

const TrashCan = props => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M2.5 7.5H5.5M21.5 7.5H18.5M5.5 7.5L6.5 20.5H12H17.5L18.5 7.5M5.5 7.5H7.5H18.5"
                stroke="#333333"
                strokeWidth="3"
            />
            <path d="M7.75 3.5H16.25" stroke="#333333" strokeWidth="3" />
        </Icon>
    )
}

const Plus = props => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M12 4V20" stroke="currentColor" strokeWidth="3" />
            <path d="M4 12L20 12" stroke="currentColor" strokeWidth="3" />
        </Icon>
    )
}

const Tick = createIcon({
    displayName: 'Tick',
    viewBox: '0 0 16 16',
    path: (
        <path
            d="M2 7.81206L6.12337 12L14 4"
            stroke="#4FAF54"
            strokeWidth="3"
            fill="none"
        />
    ),
})

const Download = props => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M3 15.5L3.0003 20.5604H21V15.5"
                stroke="#333333"
                strokeWidth="3"
                fill="none"
            />
            <path
                d="M12.0215 14L12.0215 2"
                stroke="#333333"
                strokeWidth="3"
                fill="none"
            />
            <path
                d="M6.51953 9.52174L12.0195 15L17.5195 9.52174"
                stroke="#333333"
                strokeWidth="3"
                fill="none"
            />
        </Icon>
    )
}

export { Download, FileIcon, Plus, Tick, TrashCan }
